export const apiPrefix = process.env.REACT_APP_API_PREFIX
export const graphqlEndpoint = `${apiPrefix}/graphql`
export function saveAuth(auth: string) {
  localStorage.setItem("auth", auth)
}
export function getAuthHeader(): Record<string, string> {
  return { Authorization: `Bearer ${localStorage.getItem("auth")}` }
}

export async function fetchGraphQL<TData, TVariables>(
  query: string,
  headers: Record<string, string> = {},
  variables?: TVariables
): Promise<TData> {
  const response = await fetch(graphqlEndpoint, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...headers,
    },
    body: JSON.stringify({
      query,
      variables,
    }),
  })

  const json = await response.json()

  // 处理 GraphQL 错误
  if (json.errors) {
    const { message } = json.errors[0] || {}
    throw new Error(message || "Error…")
  }

  return json.data
}
